var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(!_vm.$route.path.includes('/login') && !_vm.$route.path.includes('/reset') && !_vm.$route.path.includes('/pg'))?_c('NavBar',{attrs:{"name":_vm.name}}):_vm._e(),_c('router-view',{staticStyle:{"height":"calc(100% - 119px)"}}),(!_vm.$route.path.includes('/pg'))?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }